export const aggregateMap = {
  _avg: true,
  _count: true,
  _sum: true,
  _min: true,
  _max: true,
}
